export const EditGoalCheckboxRow = {
  mounted() {
    const el = this.el
    const pushEventTo = this.pushEventTo.bind(this)
    const dataset = el.dataset
    const input = document.getElementById(dataset.inputId)
    const checkbox = document.getElementById(dataset.checkboxId)
    const overlay = document.getElementById(dataset.overlayId)

    let focused = false
    let blurred = false

    const focusListener = () => {
      pushEventTo(
        el,
        "focus-goal-input",
        {
          "target-active-key": dataset.targetActiveKey,
          "target-count-key": dataset.targetCountKey,
        },
        () => {
          if (focused) {
            focused = false
            return
          }
          setTimeout(() => input.focus(), 0)
        },
      )
    }

    const blurListener = (overrideActive = false) => {
      pushEventTo(
        el,
        "blur-goal-input",
        {
          "target-active-key": dataset.targetActiveKey,
          "target-count-key": dataset.targetCountKey,
          "target-value": input.value,
          "override-active": overrideActive,
        },
        () => {
          if (blurred) {
            blurred = false
            return
          }
          setTimeout(() => input.blur(), 0)
        },
      )
    }

    checkbox.addEventListener("change", () => {
      if (checkbox.checked) {
        focusListener()
      } else {
        blurListener(true)
      }
    })

    input.addEventListener("focus", () => {
      focused = true
      focusListener()
    })
    input.addEventListener("blur", () => {
      blurred = true
      blurListener()
    })

    overlay.addEventListener("click", focusListener)
  },
}
